import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

import { getDocumentName, getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { PennylaneAccountRow } from '../ThirdPartyCommon/PennylaneAccountRow';

import { OrganizationPage_OneOrganization_QueryDocument } from './hooks/useFindOneOrganizationQuery.hook';

export const OrganizationPage_Pennylane_Organization_Fragment = graphql(`
  fragment OrganizationPage_Pennylane_Organization_Fragment on Organization {
    _id
    pennylaneCustomerBridges {
      _id
      userAccount
      activeId
    }
  }
`);

interface Props {
  readonly organization: FragmentType<
    typeof OrganizationPage_Pennylane_Organization_Fragment
  >;
}

export const Pennylane = ({ organization: pOrganization }: Readonly<Props>) => {
  const organization = getFragmentData(
    OrganizationPage_Pennylane_Organization_Fragment,
    pOrganization,
  );

  const { pennylaneUserAccounts } = useReferencesContext();

  return (
    <Stack divider={<Divider />} spacing={0} sx={{ flexGrow: 1 }}>
      {pennylaneUserAccounts.map((account) => {
        const bridge = organization.pennylaneCustomerBridges?.find(
          (b) => b.userAccount === account.code,
        );

        return (
          <PennylaneAccountRow
            accountCode={account.code}
            accountLabel={account.label}
            activeId={bridge?.activeId}
            invalidateQueryKey={[
              getDocumentName(OrganizationPage_OneOrganization_QueryDocument),
              { id: organization._id },
            ]}
            isEnabled={account.isEnabled}
            key={account._id}
            thirdPartyId={organization._id}
          />
        );
      })}
    </Stack>
  );
};
